/** Claims de privilégio (fonte: `GET /api/usuarios/me/permissoes`). Formato: `hub.<modulo>:<acao>`; a lista fixada fica em `claims.fixture.ts`. */
export const HUB_PERMISSOES = {
  /** Visualização de equipe de obra. */
  EQUIPES_VISUALIZACAO: "hub.equipe:visualizar",
  /** Cadastro/edição de equipe de obra (HU 2050/2051). */
  EQUIPES_CADASTRO: "hub.equipe:editar",
  /** Exportação (Excel/CSV/PDF) da listagem e do detalhe de embarcação (HU 2388). */
  EMBARCACOES_EXPORTACAO: "hub.embarcacao:exportar",
  /** Consulta de obras do Financeiro (HU 2670): aplicada pela API, que responde 403 sem ele. */
  FINANCEIRO_OBRAS_CONSULTA: "hub.financeiro:visualizar-painel",
  /** Consulta de fichas financeiras da obra (HU 2679): oculta a ação sem o privilégio. */
  FINANCEIRO_FICHAS_CONSULTA: "hub.financeiro:visualizar-fmm",
  /** Exportação e e-mail da ficha financeira (HU 2689): oculta as ações sem o privilégio. */
  FINANCEIRO_FICHAS_EXPORTACAO: "hub.financeiro:editar-fmm",
  /** Geração de ficha financeira da obra (HU 2684) e inclusão/remoção de anexos (HU 2688): oculta as ações sem o privilégio. */
  FINANCEIRO_FICHAS_GERACAO: "hub.financeiro:gerar-ficha",
  /** Edição do rótulo das claims no catálogo da aba Permissões. */
  PERMISSAO_EDICAO: "hub.permissao:editar",
  /** Visualizar auditoria. */
  AUDITORIA_VIEW: "hub.auditoria:visualizar",
  /** Cadastrar embarcações. */
  EMBARCACAO_ADD: "hub.embarcacao:cadastrar",
  /** Aprovar cadastro de embarcações. */
  EMBARCACAO_APPROVE_CADASTRO: "hub.embarcacao:aprovar-cadastro",
  /** Atualizar financeiros padrão. */
  EMBARCACAO_EDIT_FINANCEIRO: "hub.embarcacao:editar-financeiro",
  /** Visualizar embarcações. */
  EMBARCACAO_VIEW: "hub.embarcacao:visualizar",
  /** Cadastrar profissionais. */
  EQUIPE_ADD_PROFISSIONAL: "hub.equipe:cadastrar-profissional",
  /** Simular alocação. */
  EQUIPE_APPLY: "hub.equipe:simular-alocacao",
  /** Aprovar alocação do coordenador. */
  EQUIPE_APPROVE_ALOCACAO: "hub.equipe:aprovar-alocacao",
  /** Cadastrar estaleiro e PPU anual. */
  ESTALEIRO_ADD_ESTALEIRO: "hub.estaleiro:cadastrar-estaleiro",
  /** Emitir pedidos de compra. */
  ESTALEIRO_ADD_PEDIDO: "hub.estaleiro:emitir-pedido",
  /** Cadastrar PPU da obra. */
  ESTALEIRO_ADD_PPU: "hub.estaleiro:cadastrar-ppu",
  /** Aprovar pedidos de compra. */
  ESTALEIRO_APPROVE_PEDIDO: "hub.estaleiro:aprovar-pedido",
  /** Gerenciar saldos do estaleiro. */
  ESTALEIRO_MANAGE_SALDO: "hub.estaleiro:gerenciar-saldo",
  /** Criar escopo macro. */
  FINANCEIRO_ADD_ESCOPO: "hub.financeiro:criar-escopo",
  /** Criar nova obra financeira. */
  FINANCEIRO_ADD_OBRA: "hub.financeiro:criar-obra",
  /** Criar orçamentos. */
  FINANCEIRO_ADD_ORCAMENTO: "hub.financeiro:criar-orcamento",
  /** Criar outlooks. */
  FINANCEIRO_ADD_OUTLOOK: "hub.financeiro:criar-outlook",
  /** Criar simulações financeiras. */
  FINANCEIRO_ADD_SIMULACAO: "hub.financeiro:criar-simulacao",
  /** Criar template. */
  FINANCEIRO_ADD_TEMPLATE: "hub.financeiro:criar-template",
  /** Criar tipo de obra. */
  FINANCEIRO_ADD_TIPO: "hub.financeiro:criar-tipo",
  /** Aplicar template. */
  FINANCEIRO_APPLY_TEMPLATE: "hub.financeiro:aplicar-template",
  /** Aprovar empresa. */
  FINANCEIRO_APPROVE_EMPRESA: "hub.financeiro:aprovar-empresa",
  /** Aprovar escopo macro. */
  FINANCEIRO_APPROVE_ESCOPO: "hub.financeiro:aprovar-escopo",
  /** Aprovar fichas financeira e FMM. */
  FINANCEIRO_APPROVE_FICHA: "hub.financeiro:aprovar-ficha",
  /** Aprovar nova obra. */
  FINANCEIRO_APPROVE_OBRA: "hub.financeiro:aprovar-obra",
  /** Aprovar orçamentos. */
  FINANCEIRO_APPROVE_ORCAMENTO: "hub.financeiro:aprovar-orcamento",
  /** Aprovar outlooks. */
  FINANCEIRO_APPROVE_OUTLOOK: "hub.financeiro:aprovar-outlook",
  /** Aprovar parâmetros financeiros. */
  FINANCEIRO_APPROVE_PARAMETRO_FINANCEIRO: "hub.financeiro:aprovar-parametro-financeiro",
  /** Aprovar parâmetros técnicos. */
  FINANCEIRO_APPROVE_PARAMETRO_TECNICO: "hub.financeiro:aprovar-parametro-tecnico",
  /** Aprovar projeção e contingência. */
  FINANCEIRO_APPROVE_PROJECAO_CONTINGENCIA: "hub.financeiro:aprovar-projecao-contingencia",
  /** Aprovar status financeiro. */
  FINANCEIRO_APPROVE_STATUS: "hub.financeiro:aprovar-status",
  /** Aprovar template. */
  FINANCEIRO_APPROVE_TEMPLATE: "hub.financeiro:aprovar-template",
  /** Aprovar tipo de obra. */
  FINANCEIRO_APPROVE_TIPO: "hub.financeiro:aprovar-tipo",
  /** Confirmar configuração de custos. */
  FINANCEIRO_CONFIRM_CUSTOS: "hub.financeiro:confirmar-custos",
  /** Editar cenários. */
  FINANCEIRO_EDIT_CENARIO: "hub.financeiro:editar-cenario",
  /** Editar configurações financeiras (criar, editar, ativar e inativar). */
  FINANCEIRO_EDIT_CONFIGURACAO: "hub.financeiro:editar-configuracao",
  /** Editar detalhamento financeiro. */
  FINANCEIRO_EDIT_DETALHE: "hub.financeiro:editar-detalhe",
  /** Incluir ou editar empresa. */
  FINANCEIRO_EDIT_EMPRESA: "hub.financeiro:editar-empresa",
  /** Editar parâmetros financeiros. */
  FINANCEIRO_EDIT_PARAMETRO_FINANCEIRO: "hub.financeiro:editar-parametro-financeiro",
  /** Editar parâmetros técnicos. */
  FINANCEIRO_EDIT_PARAMETRO_TECNICO: "hub.financeiro:editar-parametro-tecnico",
  /** Gerenciar saldos e contingências. */
  FINANCEIRO_MANAGE_SALDO: "hub.financeiro:gerenciar-saldo",
  /** Projetar custos. */
  FINANCEIRO_PROJECT_CUSTOS: "hub.financeiro:projetar-custos",
  /** Salvar status financeiro. */
  FINANCEIRO_SAVE_STATUS: "hub.financeiro:salvar-status",
  /** Visualizar cenários. */
  FINANCEIRO_VIEW_CENARIO: "hub.financeiro:visualizar-cenario",
  /** Visualizar configurações financeiras. */
  FINANCEIRO_VIEW_CONFIGURACAO: "hub.financeiro:visualizar-configuracao",
  /** Visualizar detalhamento financeiro. */
  FINANCEIRO_VIEW_DETALHE: "hub.financeiro:visualizar-detalhe",
  /** Visualizar empresas. */
  FINANCEIRO_VIEW_EMPRESA: "hub.financeiro:visualizar-empresa",
  /** Visualizar indicadores financeiros. */
  FINANCEIRO_VIEW_INDICADOR: "hub.financeiro:visualizar-indicador",
  /** Visualizar orçamentos. */
  FINANCEIRO_VIEW_ORCAMENTO: "hub.financeiro:visualizar-orcamento",
  /** Visualizar outlooks. */
  FINANCEIRO_VIEW_OUTLOOK: "hub.financeiro:visualizar-outlook",
  /** Visualizar parâmetros. */
  FINANCEIRO_VIEW_PARAMETRO: "hub.financeiro:visualizar-parametro",
  /** Acessar projeções. */
  FINANCEIRO_VIEW_PROJECAO: "hub.financeiro:visualizar-projecao",
  /** Visualizar saldos e contingências. */
  FINANCEIRO_VIEW_SALDO: "hub.financeiro:visualizar-saldo",
  /** Visualizar simulações financeiras. */
  FINANCEIRO_VIEW_SIMULACAO: "hub.financeiro:visualizar-simulacao",
  /** Visualizar templates. */
  FINANCEIRO_VIEW_TEMPLATE: "hub.financeiro:visualizar-template",
  /** Criar GMUD. */
  GMUD_ADD: "hub.gmud:criar",
  /** Aprovar GMUD. */
  GMUD_APPROVE: "hub.gmud:aprovar",
  /** Atualizar GMUD. */
  GMUD_EDIT: "hub.gmud:editar",
  /** Visualizar GMUD. */
  GMUD_VIEW: "hub.gmud:visualizar",
  /** Editar indicadores e textos. */
  INICIO_EDIT: "hub.inicio:editar",
  /** Visualizar início financeiro. */
  INICIO_VIEW_FINANCEIRO: "hub.inicio:visualizar-financeiro",
  /** Visualizar início técnico. */
  INICIO_VIEW_TECNICO: "hub.inicio:visualizar-tecnico",
  /** Criar obra. */
  OBRA_ADD: "hub.obra:criar",
  /** Cadastrar avanço físico. */
  OBRA_ADD_AVANCO: "hub.obra:cadastrar-avanco",
  /** Solicitar código M. */
  OBRA_ADD_CODIGO_M: "hub.obra:solicitar-codigo-m",
  /** Cadastrar diário de obras. */
  OBRA_ADD_DIARIO: "hub.obra:cadastrar-diario",
  /** Cadastrar fato relevante. */
  OBRA_ADD_FATO: "hub.obra:cadastrar-fato",
  /** Criar GMUD a partir da obra. */
  OBRA_ADD_GMUD: "hub.obra:criar-gmud",
  /** Incluir lista de materiais. */
  OBRA_ADD_LISTA_MATERIAL: "hub.obra:incluir-lista-material",
  /** Criar grupo de materiais. */
  OBRA_ADD_MATERIAL: "hub.obra:criar-material",
  /** Incluir medição do estaleiro. */
  OBRA_ADD_MEDICAO: "hub.obra:incluir-medicao",
  /** Aprovar avanço físico. */
  OBRA_APPROVE_AVANCO: "hub.obra:aprovar-avanco",
  /** Aprovar diário de obras. */
  OBRA_APPROVE_DIARIO: "hub.obra:aprovar-diario",
  /** Aprovar equipe técnica. */
  OBRA_APPROVE_EQUIPE: "hub.obra:aprovar-equipe",
  /** Aprovar escopo macro. */
  OBRA_APPROVE_ESCOPO: "hub.obra:aprovar-escopo",
  /** Aprovar GMUD da obra. */
  OBRA_APPROVE_GMUD: "hub.obra:aprovar-gmud",
  /** Aprovar medição do estaleiro. */
  OBRA_APPROVE_MEDICAO: "hub.obra:aprovar-medicao",
  /** Editar equipe técnica da obra. */
  OBRA_EDIT_EQUIPE: "hub.obra:editar-equipe",
  /** Editar datas e condição da obra. */
  OBRA_EDIT_SOBRE: "hub.obra:editar-sobre",
  /** Exportar serviços da obra. */
  OBRA_EXPORT: "hub.obra:exportar",
  /** Preencher shitlist. */
  OBRA_FILL_SHITLIST: "hub.obra:preencher-shitlist",
  /** Importar lista do TM Master. */
  OBRA_IMPORT: "hub.obra:importar",
  /** Solicitar escopo macro. */
  OBRA_REQUEST_ESCOPO: "hub.obra:solicitar-escopo",
  /** Visualizar detalhamento da obra. */
  OBRA_VIEW: "hub.obra:visualizar",
  /** Visualizar materiais. */
  OBRA_VIEW_MATERIAL: "hub.obra:visualizar-material",
  /** Visualizar painel de obras. */
  OBRA_VIEW_PAINEL: "hub.obra:visualizar-painel",
  /** Visualizar serviços. */
  OBRA_VIEW_SERVICO: "hub.obra:visualizar-servico",
  /** Aprovar painel de controle. */
  PERFIL_APPROVE_PAINEL: "hub.perfil:aprovar-painel",
  /** Editar perfil (criar, alterar e excluir). */
  PERFIL_EDIT: "hub.perfil:editar",
  /** Visualizar perfis. */
  PERFIL_VIEW: "hub.perfil:visualizar",
  /** Visualizar permissões. */
  PERMISSAO_VIEW: "hub.permissao:visualizar",
  /** Criar relatórios padrão. */
  RELATORIO_ADD_PADRAO: "hub.relatorio:criar-padrao",
  /** Criar relatórios personalizados. */
  RELATORIO_ADD_PERSONALIZADO: "hub.relatorio:criar-personalizado",
  /** Exportar relatórios. */
  RELATORIO_EXPORT: "hub.relatorio:exportar",
  /** Visualizar relatórios. */
  RELATORIO_VIEW: "hub.relatorio:visualizar",
  /** Editar usuário. */
  USUARIO_EDIT: "hub.usuario:editar",
  /** Visualizar usuários. */
  USUARIO_VIEW: "hub.usuario:visualizar",
} as const;

export type HubClaim = (typeof HUB_PERMISSOES)[keyof typeof HUB_PERMISSOES];
